import axiosInstance from '../lib/axiosInstance';

export const requestOffers = async (filters, { page, order }) => {
  return axiosInstance.post('/offers/request', {
    filters,
    page,
    order
  });
};

export const getBestOffers = async (filters) => {
  return axiosInstance.post('/offers/best', {
    filters,
  });
};

export const getSchedule = async (filters) => {
  return axiosInstance.get('/trips/schedule', { params: filters });
};

export const createBooking = async (reference, payload, options = {}) => {
  const headers = {};
  if (options.jwt) headers.Authorization = `Bearer ${options.jwt}`;

  return axiosInstance.post('/bookings',
    {
      reference,
      payload: payload
    },
    { headers }
  );
};